import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type OzonLogisticsConnectResponse as SchemaOzonLogisticsConnectResponse } from '../schemas/OzonLogisticsConnectResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Подключает магазин к Ozon Доставке (если ещё не подключён) и возвращает список доступных схем (FBO, FBS).

 * @tags Integrations
 * @summary Подключить Ozon Доставку
 */
export const ConnectOzonLogisticsContentType = '' as const;
export type ConnectOzonLogisticsRequest = void;
export type ConnectOzonLogisticsResponses = LinkCommonErrorResponses & {
    /**
     * @description Ozon Logistics connected successfully
     */
    '200': {
        'application/json': SchemaOzonLogisticsConnectResponse;
    };
};
export type ConnectOzonLogisticsResponseSuccess = ConnectOzonLogisticsResponses['200']['application/json'];
export type ConnectOzonLogisticsSearchParams = undefined;
export type ConnectOzonLogisticsPathParameters = undefined;
export const ConnectOzonLogisticsUrl = '/integrations/ozon/logistics' as const;
export const ConnectOzonLogisticsMethod = 'POST' as const;
export const getConnectOzonLogisticsUrl = (_params?: ConnectOzonLogisticsPathParameters) => ConnectOzonLogisticsUrl;
